module.exports = __webpack_public_path__ + "static/media/37550021-W7D0wSgs.7c8ed74f.JPG";